import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 9h8","key":"svg-0"}],["path",{"d":"M8 13h6","key":"svg-1"}],["path",{"d":"M13 18l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6","key":"svg-2"}],["path",{"d":"M17 17v5","key":"svg-3"}],["path",{"d":"M21 17v5","key":"svg-4"}]]

const IconMessagePause = createReactComponent('outline', 'message-pause', 'MessagePause', __iconNode);

export default IconMessagePause;